var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.customClass,attrs:{"color":_vm.colorString,"type":"submit","disabled":_vm.disabledButton,"text":_vm.text}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }